/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OutputZoneRequestsZonesSelector
 */
export interface OutputZoneRequestsZonesSelector {
    /**
     * 
     * @type {number}
     * @memberof OutputZoneRequestsZonesSelector
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof OutputZoneRequestsZonesSelector
     */
    name: string;
}

/**
 * Check if a given object implements the OutputZoneRequestsZonesSelector interface.
 */
export function instanceOfOutputZoneRequestsZonesSelector(value: object): boolean {
    if (!('id' in value)) return false;
    if (!('name' in value)) return false;
    return true;
}

export function OutputZoneRequestsZonesSelectorFromJSON(json: any): OutputZoneRequestsZonesSelector {
    return OutputZoneRequestsZonesSelectorFromJSONTyped(json, false);
}

export function OutputZoneRequestsZonesSelectorFromJSONTyped(json: any, ignoreDiscriminator: boolean): OutputZoneRequestsZonesSelector {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
    };
}

export function OutputZoneRequestsZonesSelectorToJSON(value?: OutputZoneRequestsZonesSelector | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'name': value['name'],
    };
}

